import { render, staticRenderFns } from "./MoleculeConfigHistoryCard.vue?vue&type=template&id=e50b9408&scoped=true&"
import script from "./MoleculeConfigHistoryCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeConfigHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeConfigHistoryCard.vue?vue&type=style&index=0&id=e50b9408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50b9408",
  null
  
)

export default component.exports